var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import FloatPortal from '../Portal/FloatPortal';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import Alternates from '../AlternateComponents/Alternates';
let AlternativeForCompPopover = class AlternativeForCompPopover extends Vue {
  get isDesignerDragging() {
    const {
      currentOperation
    } = this.designer;
    return currentOperation === 'binding' || currentOperation === 'dragging';
  }
  calcPosition() {
    var _this$$el$parentEleme;
    const content = this.$refs.content;
    const height = content === null || content === void 0 ? void 0 : content.offsetHeight;
    const width = content === null || content === void 0 ? void 0 : content.offsetWidth;
    const {
      top: parentTop,
      left: parentLeft,
      width: parentWidth
    } = ((_this$$el$parentEleme = this.$el.parentElement) === null || _this$$el$parentEleme === void 0 ? void 0 : _this$$el$parentEleme.getBoundingClientRect()) || {
      top: 0,
      left: 0,
      width: 0
    };
    if (content && window.innerHeight < parentTop + height) {
      content.style.marginTop = `${window.innerHeight - (parentTop + height + 16)}px`;
    }
    if (content && window.innerWidth < parentLeft + width) {
      content.style.transform = `translateX(calc(-100% - ${parentWidth}px))`;
    }
  }
  async mounted() {
    await this.$nextTick();
    this.calcPosition();
  }
  render() {
    var _this$value;
    const h = arguments[0];
    return h(FloatPortal, [h("div", {
      "class": mergeClassName('ucd-dataTreeNode-components', 'ucd-dataTreeNode-components-hideCatalogue', this.isDesignerDragging && 'ucd-dataTreeNode-components-hidden', 'ucd-alterComp'),
      "on": {
        "mouseenter": () => this.$emit('mouseenter'),
        "mouseleave": () => this.$emit('mouseleave')
      },
      "ref": "content"
    }, [h("div", {
      "class": "ucd-alterComp-title"
    }, [h("b", [" ", ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.name) || '未知组件', " "])]), h(Alternates, {
      "attrs": {
        "dataPath": this.dataPath,
        "value": this.value,
        "dragTitle": this.dragTitle,
        "dragSource": this.dragSource
      },
      "on": {
        "dragstart": value => this.$emit('dragstart', value),
        "dragend": value => this.$emit('dragend', value),
        "switch": value => this.$emit('switch', value),
        "loaded": this.calcPosition
      }
    })])]);
  }
};
AlternativeForCompPopover = __decorate([Component({
  name: 'AlternativeForCompPopover',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {
    dataPath: String,
    value: {
      required: false,
      type: Object
    },
    dragTitle: String,
    dragSource: Object
  }
})], AlternativeForCompPopover);
export default AlternativeForCompPopover;
//# sourceMappingURL=AlternativeForCompPopover.js.map
